import { Navigate } from "react-router-dom";
import { auth } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";

export default function PrivateRoute({ children }) {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
         <div
  className="animate-spin rounded-full h-12 w-12 border-4"
  style={{
    borderTopColor: "transparent",
    borderRightColor: "#f0b632",
    borderBottomColor: "#f0b632",
    borderLeftColor: "#f0b632",
  }}
></div>

      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return children;
}
